import Breadscrumbs from './Breadscrumbs';

export default Breadscrumbs;
